import { getOpacityColor, grayScale } from "@enkor/design/colors";

export const iconButtonAnimation = {
  whileHover: {
    backgroundColor: getOpacityColor(grayScale.white, 0.15),
    transition: { duration: 0.2, ease: [0.0, 0.0, 0.0, 1.0] },
  },
  whileTap: {
    backgroundColor: getOpacityColor(grayScale.white, 0.3),
    transition: { duration: 0.2, ease: [0.0, 0.0, 0.0, 1.0] },
  },
};

export const getColorButtonAnimation = ({
  hoverColor,
  tapColor,
}: {
  hoverColor: string;
  tapColor: string;
}) => ({
  whileHover: {
    backgroundColor: hoverColor,
    transition: { duration: 0.2, ease: [0.4, 0, 0.2, 1] },
  },
  whileTap: {
    backgroundColor: tapColor,
    transition: { duration: 0.2, ease: [0.4, 0, 0.2, 1] },
  },
});
